var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCutVideo = function SvgCutVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#393F4F",
    d: "M60.3 20c-.2 0-.4 0-.6.2l-19 14.3-12.4-9.3.2-.7c.3-1 .5-2 .5-3 0-5.2-4.3-9.5-9.5-9.5S10 16.3 10 21.5s4.3 9.5 9.5 9.5c2.9 0 5.6-1.3 7.4-3.6l.6-.8 11.8 8.9-11.8 8.9-.6-.8c-1.8-2.3-4.5-3.6-7.4-3.6-5.2 0-9.5 4.3-9.5 9.5s4.3 9.5 9.5 9.5 9.5-4.3 9.5-9.5c0-1-.2-2-.5-3l-.2-.7 12.4-9.3 19 14.3c.4.3.9.2 1.2-.2.3-.3.2-.9-.2-1.1L42 35.5l18.6-14c.4-.3.4-.8.2-1.2-.1-.1-.3-.3-.5-.3zm-40.8 9.3c-4.3 0-7.8-3.5-7.8-7.8s3.5-7.8 7.8-7.8 7.8 3.5 7.8 7.8-3.5 7.8-7.8 7.8zm0 28c-4.3 0-7.8-3.5-7.8-7.8s3.5-7.8 7.8-7.8 7.8 3.5 7.8 7.8-3.5 7.8-7.8 7.8z"
  })));
};
export default SvgCutVideo;